import { Link } from "react-router";

import "../assets/scss/components/_home-upsell.scss";
import BirthdayImg from "../assets/images/headers/birthday-flowers-full-width.jpg";
import LuxuryImg from "../assets/images/headers/luxury-flowers-full-width.jpg";
import HeaderImg from "../assets/images/headers/rose-and-lily-full-width.jpg";
import PaddingtonImg from "../assets/images/headers/paddingtonbear-full-width.jpg";
import MaroonLogo from "../assets/images/123-Logo-Horizontal-Maroon.png";
import PaddingtonLogo from "../assets/images/logos/paddington-since-1958.png";
import { useAppContext } from "../contexts/AppContext";
import { useAppStore } from "../stores/AppStore";
import { Image } from "./Image";
import { Slider } from "./Slider";

export const HomeUpsell = () => {
	const appData = useAppContext();
	const { peakConfigs: storedPeakConfigs } = useAppStore(({ peakConfigs }) => ({ peakConfigs }));
	const peakConfigs = appData?.peakConfigs || storedPeakConfigs;

	let headerLink = "/next-day-flowers";
	let headerText = "Next Day Flowers";
	let headerDesc = "From £19.99 with FREE delivery!";
	let headerImage = HeaderImg;
	let headerClass = "";
	let headerButtonText = "Shop Now";

	if (peakConfigs?.VALENTINES_HEADER) {
		headerClass = "valentines-upsell";
		headerLink = "/valentines-flowers";
		headerText = "Valentine's Flowers";
		headerDesc = "From £19.99 with FREE delivery!";
		// headerImage = ValentinesImg;
		headerButtonText = "Shop Now";
		headerClass = "valentines-day-upsell";
	}

	if (peakConfigs?.MOTHERS_DAY) {
		headerClass = "mothers-day-upsell";
		headerLink = "/mothers-day-flowers";
		headerText = "Mother's Day Flowers";
		headerDesc = "From £19.99 with FREE delivery!";
		// headerImage = MothersDayImg;
		headerClass = "mothers-day-upsell";
	}

	if (peakConfigs?.CHRISTMAS_HEADER) {
		headerClass = "christmas-upsell";
		headerLink = "/christmas-flowers";
		headerText = "Christmas Flowers";
		headerDesc = "Enjoy beautiful seasonal bouquets perfect for every occasion including Birthdays, Anniversaries and more! Including beautiful seasonal Tulips lovingly handtied by expert florists!";
		// headerImage = XmasImage;
	}

	let slides = [];
	slides = [
		{
			element: (
				<HomeUpsellSlide
					slide={{
						headerLink: "/next-day-flowers",
						headerText: "Next Day Flowers",
						headerDesc: "From £19.99 with FREE delivery!",
						headerImage: HeaderImg,
						headerClass: "",
						headerButtonText: "Shop Now",
						bgColor: "#F8B5BF",
					}}
				/>
			),
		},
		{
			element: (
				<HomeUpsellSlide
					slide={{
						headerLink: "/flowers-with-teddy",
						headerLogos: [{ "123 Flowers": MaroonLogo }],
						headerText: "Paddington",
						headerDesc: "Include a Paddington Bear with your bouquet at checkout",
						headerDescClr: "#056298",
						headerImage: PaddingtonImg,
						headerClass: "",
						headerButtonText: "Shop Now",
						bgColor: "#F8B5BF",
						btnColor: "#E83741",
					}}
				/>
			),
		},
		{
			element: (
				<HomeUpsellSlide
					slide={{
						headerLink: "/birthday-flowers",
						headerText: "Birthday Flowers",
						headerDesc: "From £19.99 with FREE delivery!",
						headerImage: BirthdayImg,
						headerClass: "",
						headerButtonText: "Shop Now",
						bgColor: "#FEF1E6",
					}}
				/>
			),
		},
		{
			element: (
				<HomeUpsellSlide
					slide={{
						headerLink: "/luxury-flowers",
						headerText: "Luxury Flowers",
						headerDesc: "From £19.99 with FREE delivery!",
						headerImage: LuxuryImg,
						headerClass: "",
						headerButtonText: "Shop Now",
						bgColor: "#FDA54C",
						titleColor: "black",
						color: "black",
					}}
				/>
			),
		},
	];

	if (peakConfigs?.VALENTINES_HEADER) {
		slides = [];
	}

	return (
		<>
			<section className={`home-upsell ${headerClass ?? ""}`}>
				<Slider
					slides={slides}
					prefix="home-upsell-slider"
					slides_per_row={{ base: 1, md: 1 }}
					autoplay={true}
					slide_duration={3}
					arrows={true}
				/>
			</section>
		</>
	);
};

const HomeUpsellSlide = ({ slide }) => {
	return (
		<div
			className="biggest-trends"
			style={{
				// backgroundImage: `url(${HeaderImg})`,
				// backgroundSize: "55%"
				"--bg": slide.bgColor || "",
				"--color": slide.color || "",
				"--title-color": slide.titleColor || "",
			}}
		>
			<div className="row align-items-stretch no-wrap">
				<div className="upsell-img col-12">
					<Image
						src={slide.headerImage}
						alt={slide.headerText}
						imported={true}
						sizes="100vw"
						width={1920}
						height={400}
						srcSetWidths={[720, 1080, 1920, 2560]}
					/>
				</div>

				<div className="col-12 col-lg-8 trend-description">
					{slide.headerLogos ? (
						<div className="upsell-logos">
							{slide.headerLogos.map((logo, index) => {
								const [alt, src] = Object.entries(logo)[0];
								return (
									<>
										<img
											className="upsell-logo"
											key={index}
											src={src as string}
											alt={alt as string}
										/>
										{index === 0 ? <strong className="upsell-x">X</strong> : null}
										<strong className="upsell-title">{slide.headerText}</strong>
									</>
								);
							})}
						</div>
					) : (
						<strong className="upsell-title">{slide.headerText}</strong>
					)}

					<p
						className="upsell-description"
						style={slide.headerDescClr ? { color: slide.headerDescClr } : {}}
					>
						{slide.headerDesc}
					</p>

					<Link
						to={slide.headerLink}
						className="btn minimal"
						style={slide.btnColor ? { backgroundColor: slide.btnColor } : {}}
					>
						{slide.headerButtonText}
					</Link>
				</div>
			</div>
		</div>
	);
};
